// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.accounting.eyefinity.AdminEyefinityFeeOptionResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminEyefinityFeeOptionResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	chargeBack!: number | null;

	@GandalfProperty({ designType: String })
	code!: string | null;

	@GandalfProperty({ designType: Number })
	eyefinityFeeOptionId!: number | null;

	@GandalfProperty({ designType: String })
	optionName!: string | null;

	@GandalfConstantDecorator(constants.EyefinityFeeOptionType)
	@GandalfProperty({ designType: constants.EyefinityFeeOptionType })
	optionType!: constants.EyefinityFeeOptionType | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	patientFee!: number | null;

	@GandalfProperty({ designType: Number })
	patientPercentageRetailCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	serviceFee!: number | null;

}
